"use client";

import type { PropsWithChildren } from "react";

export function Announcement(props: PropsWithChildren) {
  const showAnnouncement =
    new Date() >= new Date("2026-07-21") && new Date() <= new Date("2026-08-17T23:59:59");

  return (
    showAnnouncement && (
      <div className="bg-accent px-page py-2.5 text-center text-sm text-white">
        {props.children}
      </div>
    )
  );
}
